import React from "react";
import { Link, useLocation } from "react-router-dom";

export function LogoMark({ className = "w-10 h-10" }) {
    return (
        <span className={`${className} rounded-xl bg-polley-forest flex items-center justify-center flex-none`}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#CFE0D2" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M4 5h16v11H9l-5 4z" />
                <path d="M8.5 10.5l2.5 2.5 4.5-5" />
            </svg>
        </span>
    );
}

const NavLink = ({ to, children }) => {
    const { pathname } = useLocation();
    const active = pathname === to;
    return (
        <Link
            to={to}
            aria-current={active ? "page" : undefined}
            className={`px-4 py-2.5 rounded-full text-[15px] no-underline ${
                active ? "bg-white text-polley-ink font-semibold" : "text-polley-muted font-medium hover:text-polley-ink"
            }`}
        >
            {children}
        </Link>
    );
};

export const Layout = ({ children }) => {
    const { pathname } = useLocation();
    // On a phone the poll page brings its own compact header, as in the design.
    const isPoll = pathname.startsWith("/poll/");

    return (
        <div className="min-h-screen flex flex-col bg-polley-ground text-polley-ink font-sans">
            <header className={`px-4 sm:px-6 py-5 ${isPoll ? "hidden md:block" : ""}`}>
                <div className="max-w-[1120px] mx-auto flex items-center justify-between gap-4 flex-wrap">
                    <Link to="/" className="flex items-center gap-3 text-polley-ink no-underline">
                        <LogoMark />
                        <span className="font-display font-extrabold text-2xl tracking-tight">Polley</span>
                    </Link>
                    <nav aria-label="Main" className="flex gap-1">
                        <NavLink to="/">Home</NavLink>
                        <NavLink to="/about">About</NavLink>
                    </nav>
                </div>
            </header>

            <main className="flex-grow">{children}</main>

            <footer className={`px-6 py-6 border-t border-polley-line ${isPoll ? "hidden md:block" : ""}`}>
                <div className="max-w-[1120px] mx-auto flex justify-between items-center gap-3 flex-wrap text-sm text-polley-muted">
                    <span>
                        <strong className="text-polley-ink font-display">Polley</strong>, made for easy collaboration
                    </span>
                    <Link to="/about" className="text-polley-muted hover:text-polley-ink">About</Link>
                </div>
            </footer>
        </div>
    );
};
